export const overlay = `fixed top-0 left-0 right-0 bottom-0 z-20 opacity-40 bg-ll-placeholder rounded inset-0`;

export const content = `
  fixed top-0 left-0 h-full w-full

  md:top-1/2 md:max-h-[475px] md:-translate-y-1/2
  md:left-1/2 md:max-w-[600px] md:-translate-x-1/2
  
  bg-white
  py-6
  z-30
`;

export const title = `text-center font-semibold text-ll-on-background`;
export const description = `font-medium leading-6 text-ll-placeholder mt-8 mb-6 px-4`;

export const close = `absolute top-5 right-5`;
export const closeIcon = `h-8 w-8 text-ll-disabled`;

export const filters = `h-full flex flex-col justify-between`;
export const filterList = `px-4 pb-4 flex flex-wrap gap-2 overflow-y-auto`;

export const footer = `p-6 border-t border-ll-border flex justify-between items-center`;
export const resetButton = `bg-transparent text-ll-primary hover:text-ll-primary-variant-1 transition-colors p-4`;
export const saveButton = `bg-ll-primary text-white px-4 py-3 rounded hover:bg-ll-primary-variant1 transition-colors md:w-52`;
